import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    VeryBiglogo: {
      width: '50%',
      height: 'auto',
      display: 'block',
      margin: 'auto',
    },
    paddingAuto: {
      paddingTop: '75px',
    },
    container: {
      width: '95%',
      margin: '0 auto',
    },
    containerBtn: {
      margin: '2vh',
    },
    validate: {
      color: '#fff',
      backgroundColor: '#2B56A5',
      paddingLeft: '2vh',
      paddingRight: '2vh',
    },
    modalTitle: {
      color: '#E63C3C',
      marginBottom: 30,
    },
    modalText: {
      color: '#2B56A5',
      fontSize: 14,
      fontFamily: 'ITC Avant Garde Gothic Std Medium',
    },
    modalContent: {
      width: '80%',
      margin: '0 auto',
    },
    backGroundGrey: {
      width: '100%',
      background: '#e8eef4',
      color: '#2B56A5',
      paddding: '3vh',
    },
    fixed: {
      position: 'fixed',
      bottom: theme.spacing(2),
      right: theme.spacing(2),
      backgroundColor: '#2B56A5',
    },
    page: {
      maxHeight: '1754px',
      maxWidth: '1240px',
      minHeight: '147vh',
      // margin: "1vh 0",
      // [theme.breakpoints.down('sm')]: {
      //     height: "85vh",
      // },
    },
    imgpremierApercu: {
      height: '100%',
      width: '100%',
    },
    colorBlue: {
      color: '#2B56A5',
    },
    trait00: {
      backgroundColor: 'yellow',
      width: '75px',
      height: '5px',
      display: 'block',
      margin: 'auto',
      marginTop: '50px',
      marginBottom: '50px',
    },
    img: {
      width: '100%',
      height: 'auto',
    },
    title: {
      fontSize: 19,
      color: '#2b56a5',
    },
    title2: {
      fontSize: 20,
      color: '#2B56A5',
      fontWeight: 300,
    },
    paragraphe: {
      fontSize: '14px',
    },
    logo: {
      width: '50%',
      height: 'auto',
      display: 'block',
      margin: 'auto',
    },
    textLock: {
      fontFamily: 'Poppins',
      fontStyle: 'normal',
      fontSize: '16px',
      lineHeight: '140 %',
      color: '#CDCDCD',
      padding: '9vh 2vh 2vh 2vh',
      border: '1.5px solid',
      [theme.breakpoints.down('sm')]: {
        fontSize: '12px',
      },
    },
    logoOrientaction: {
      with: '100%',
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        maxWith: '100%',
      },
    },
    imgWeigth: {
      width: '25vh',
      height: '25vh',
      [theme.breakpoints.down('sm')]: {
        width: '18vh',
        height: '18vh',
      },
    },
    textTitle: {
      color: 'white',
      textAlign: 'center',
      width: '100%',
      height: 'auto',
      borderRadius: '4px 4px 0 0',
      backgroundColor: '#2B56A5',
      paddingTop: '1.5vh',
      margin: '3vh 0 0 0',
      display: 'flex',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        height: '11vh',
        fontSize: '1.5vh',
      },
    },
    borderWeither: {
      borderRadius: '0 0 4px 4px',
      border: '1px solid #2B56A5',
      width: '100%',
      height: '240px',
      display: 'block',
      marginTop: '1vh',
      [theme.breakpoints.down('sm')]: {
        height: '170px',
      },
    },
    checkBox: {
      position: 'relative',
      margin: '-6vh 2vh',
      [theme.breakpoints.down('sm')]: {
        margin: '-3.5vh 3vh',
      },
    },
    titleSteveJobs: {
      fontSize: 25,
      color: '#2B56A5',
      textAlign: 'center',
      fontWeight: 300,
      width: '90%',
      margin: '0 auto',
      lineHeight: '7vh',
      [theme.breakpoints.down('sm')]: {
        lineHeight: '4vh',
      },
    },
    listSomaine: {
      fontFamily: 'calibri',
      fontSize: 20,
      color: '#2B56A5',
      textDecoration: 'none',
    },
    marginSomaire: {
      margin: '4vh 0',
      [theme.breakpoints.down('sm')]: {
        margin: '1vh 0',
      },
    },
    aButton: {
      textDecoration: 'none',
      color: 'white',
    },
    formContent: {
      margin: '2vh auto',
      width: '100%',
    },
    couverturePage: {
      maxWidth: '100%',
      height: 'auto',
      position: 'relative',
    },
    readOnly: {
      scrollBehavior: 'smooth',
      '& input': {
        '-webkit-user-select': 'none',
        '-moz-user-select': 'none',
        '-ms-user-select': 'none',
        'user-select': 'none',
      },
    },
    bullet: {
      display: 'inline-block',
      margin: '0 2px',
      transform: 'scale(0.8)',
    },
    title00: {
      fontSize: 19,
    },
    pos: {
      marginBottom: 12,
    },
    textCenterTop: {
      textAlign: 'center',
      color: '#2b56a5',
    },
    trait: {
      backgroundColor: 'yellow',
      width: '75px',
      height: '5px',
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: '50px',
      marginBottom: '50px',
    },
    flexPosition: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    positionRelative: {
      position: 'relative',
    },
    positionAbsolute: {
      position: 'absolute',
    },
    opacity07: {
      opacity: 0.7,
    },
    colorPrimaryBook: {
      color: '#2b56a5',
    },
    noAdjustLeft: {
      '@media only screen and (max-width: 600px)': {
        textAlign: 'center !important',
      },
      '@media only screen and (max-width: 361px)': {
        textAlign: 'center !important',
      },
    },
    marginFooter: {
      marginTop: '10px',
      marginBottom: '100px',
    },
    btn012: {
      position: 'absolute',
      bottom: '3%',
      zIndex: 2,
      right: '5%',
      border: '2px solid black',
      width: '34%',
      height: '8%',
      cursor: 'pointer',
      opacity: 0,
    },
    cardImageBtn: {
      width: '100%',
      height: 'auto',
      position: 'relative',
    },
    imageBtn: {
      width: '100%',
      height: 'auto',
    },
    btnInside: {
      position: 'absolute',
      bottom: '17%',
      zIndex: 2,
      right: '25%',
      border: '2px solid black',
      width: '50%',
      height: '13%',
      cursor: 'pointer',
      opacity: 0,
    },
    textPositionInside: {
      position: 'absolute',
      color: 'white',
      padding: '6% 6% 0%',
    },
    textStyleInside: {
      fontSize: '0.7rem !important',
      textAlign: 'center',
      '@media screen and (min-width: 1215px) and (max-width: 1380px)': {
        fontSize: '0.6rem !important',
      },
      '@media screen and (min-width: 960px) and (max-width: 1215px)': {
        fontSize: '0.45rem !important',
      },
      '@media screen and (min-width: 600px) and (max-width: 872px)': {
        fontSize: '0.45rem !important',
      },
    },
    btnTest: {
      position: 'absolute',
      zIndex: 2,
      border: '2px solid black',
      width: '100%',
      height: '100%',
      cursor: 'pointer',
      opacity: 0,
      top: '0%',
      left: '0%',
    },
    containerImg: {
      position: 'relative',
      display: 'block',
      width: '100%',
      height: 'auto',
      margin: 'auto',
    },
    btn042: {
      position: 'absolute',
      bottom: '14%',
      zIndex: 2,
      right: '2%',
      border: '2px solid black',
      width: '31%',
      height: '7%',
      cursor: 'pointer',
      opacity: 0,
    },
    btn017: {
      position: 'absolute',
      bottom: '13%',
      zIndex: 2,
      left: '50%',
      border: '2px solid black',
      width: '63%',
      height: '13%',
      cursor: 'pointer',
      opacity: 0,
      transform: 'translate(-50%, -50%)',
    },
    btn033: {
      position: 'absolute',
      bottom: '2%',
      zIndex: 2,
      right: '19%',
      border: '2px solid black',
      width: '33%',
      height: '8%',
      cursor: 'pointer',
      opacity: 0,
      transform: 'translate(50%, -50%)',
    },
    btn035: {
      position: 'absolute',
      bottom: '0%',
      zIndex: 2,
      left: '50%',
      border: '2px solid black',
      width: '42%',
      height: '10%',
      cursor: 'pointer',
      opacity: 0,
      transform: 'translate(-50%, -50%)',
    },
    imgCenter: {
      width: '60%',
      height: 'auto',
      display: 'block',
      margin: 'auto',
    },
    pagePadding: {
      paddingTop: '75px',
      paddingBottom: '30px',
      paddingLeft: '100px',
      paddingRight: '100px',
      [theme.breakpoints.down('sm')]: {
        paddingTop: '75px',
        paddingBottom: '75px',
        paddingLeft: '75px',
        paddingRight: '75px',
      },
      [theme.breakpoints.down('xs')]: {
        paddingTop: '20px',
        paddingBottom: '20px',
        paddingLeft: '20px',
        paddingRight: '20px',
      },
    },
    containerTrait: {
      display: 'flex',
      alignItems: 'center',
    },
    trait2: {
      background: 'black',
      width: '100%',
      height: '2px',
    },
    imgLogo: {
      display: 'block',
      width: '100%',
      position: 'relative',
    },
    underLogo: {
      fontSize: 22,
      textAlign: 'center',
      [theme.breakpoints.down('xs')]: {
        fontSize: 15,
      },
    },
    titleSeconde: {
      fontSize: 20,
      color: '#2B56A5',
      textDecoration: 'none',
      fontFamily: 'ITC Avant Garde Gothic Std Bold',
      margin: 0,
    },
    containerCompass: {
      margin: '70px 0px 10px',
    },
    imgNeedFull: {
      display: 'block',
      width: '100%',
      height: 'auto',
    },
    marginListCompass: {
      marginBottom: 35,
      [theme.breakpoints.down('xs')]: {
        marginBottom: 20,
      },
    },
    containerListCompass: {
      paddingLeft: 30,
      [theme.breakpoints.down('xs')]: {
        paddingLeft: 0,
      },
    },
    marginLevel1: {
      margin: 20,
    },
    borderText: {
      border: "2px solid #0E1247",
      padding: 5,
    },
    fixedBtn: {
      display: 'block',
      margin: 'auto',
      padding: 20,
      height: 'auto',
      width: '60%'
    },
    imgFloat: {
      width: '45px',
      height: 'auto',
    },
    flexPositionImg: {
      display: 'flex',
      alignItems: 'flex-start',
    },
    breakWord: {
      [theme.breakpoints.down('xs')]: {
        wordBreak: 'break-word',
        hyphens: 'auto',
      },
    }
  })
);

export default useStyles;
